import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SelectOption } from "../../shared/interfaces/select-option";
import { TransactionTypeService } from "../services/transaction-type.service";

export const investmentsTransactionTypesResolver: ResolveFn<SelectOption[]> = () => {
    const service = inject(TransactionTypeService);
    return service.getTransactionTypes();
};